import { render, staticRenderFns } from "./KusOnboardingTour.vue?vue&type=template&id=6648b7a7"
import script from "./KusOnboardingTour.vue?vue&type=script&lang=js"
export * from "./KusOnboardingTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports